import { sendGet } from "../networking/api";
import { ListOption } from "./Interfaces/listOption";

export const communities = [
  "Inuvik",
  "Sachs Harbour",
  "Tuktoyaktuk",
  "Aklavik",
  "Paulatuk",
  "Ulukhaktok",
] as const;
export type Community = (typeof communities)[number];

export async function getCommunities(): Promise<ListOption[]> {
  return await sendGet<ListOption[]>("/api/communities");
}
